"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pluralize_1 = require("pluralize");
class BaseMapper {
    constructor(name, schema, config) {
        this.name = name;
        this.config = config || {};
        this.schema = schema;
    }
    static registerModel(name, model, Mapper, config) {
        BaseMapper.models[name] = {
            model,
            IDField: model.IDField
        };
        let mapper;
        //Need any as otherwise get abstract class error
        return () => {
            if (mapper)
                return mapper;
            mapper = new Mapper(name, model.schema, config);
            return mapper;
        };
    }
    async create(data) {
        const model = this.newModel(data);
        await model.commit();
        return model;
    }
    getModel() {
        return BaseMapper.models[this.name].model;
    }
    getDBName() {
        //Allow DB name to be passed in config
        if (this.config.DB_NAME)
            return this.config.DB_NAME;
        let dbName = process.env[(0, pluralize_1.plural)(this.name).toUpperCase() + '_DB'];
        if (!dbName) {
            console.log('ERROR', 'cannot find DB name', dbName);
            throw "Mapper couldn't find DB name, looking for env variable with key: " +
                (0, pluralize_1.plural)(this.name).toUpperCase() +
                '_DB';
        }
        return dbName;
    }
    newModel(data, state) {
        const Model = this.getModel();
        return new Model(this, data, state);
    }
    load(ID) {
        throw new Error('Method not implemented');
    }
    query(query) {
        throw new Error('Method not implemented');
    }
    commit(model) {
        throw new Error('Method not implemented');
    }
    update(ID, updates, expression = 'SET', returnValue = 'NONE', upsert = false) {
        throw new Error('Method not implemented');
    }
    delete(model, hardDelete) {
        throw new Error('Method not implemented');
    }
    render(obj) {
        if (obj && Array.isArray(obj)) {
            return this.convertArray(obj);
        }
        return this.convertObject(obj);
    }
    convertArray(array) {
        return {
            data: array.map(obj => this.convertObject(obj)),
        };
    }
    convertObject(obj) {
        return obj.serialize();
    }
    validate(model) {
        const schema = this.schema;
        if (!schema)
            return;
        try {
            schema.validateSync(model.toDB());
            return;
        }
        catch (ex) {
            return ex;
        }
    }
    cast(model, stripUnknown = true) {
        const schema = this.schema;
        if (!schema)
            return model.toDB();
        return schema.cast(model.toDB(), {
            stripUnknown,
            strict: true,
        });
    }
    getIDFieldName() {
        return BaseMapper.models[this.name].IDField || 'ID';
    }
    validateUpdate(model, update) {
        const schema = this.schema;
        if (!schema)
            return;
        const fullObject = Object.assign(Object.assign({}, model.toDB()), update);
        try {
            Object.keys(update).forEach(key => {
                schema.validateSyncAt(key, fullObject, {
                    stripUnknown: true
                });
            });
        }
        catch (ex) {
            console.log('Validation error', update, ex);
            throw ex;
        }
    }
}
exports.default = BaseMapper;
BaseMapper.models = {};
